export default "__VITE_ASSET__DeywwWIz__"